import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ImagePreprocessingFunction } from 'types';

interface CreatePreviewImageAsBlobParams {
  framework: string;
  frameworkVersion: string;
  functions: ImagePreprocessingFunction[];
}

type CreatePreviewImageAsBlob = (params: CreatePreviewImageAsBlobParams) => Promise<Blob>;

const createPreviewImageAsBlob: CreatePreviewImageAsBlob = async ({ framework, frameworkVersion, functions }) => {
  const { data } = await apiClient.post(
    API_END_POINT.BLOCK.CREATE_PREVIEW_IMAGE_AS_BLOB,
    {
      framework,
      frameworkVersion,
      functions,
    },
    {
      responseType: 'blob',
    }
  );

  return data;
};

export default createPreviewImageAsBlob;
